// extracted by mini-css-extract-plugin
export default {"header":"SignIn-header-OBeWC","form":"SignIn-form-YyMW3","textInput":"SignIn-textInput-fYs6u","remember":"SignIn-remember-RCSos","attribution":"SignIn-attribution-PbIbH"};